import { NFT_BREADCRUMB_WIDGET_COLORS } from "@/domains/colors/colorsets"
import { BodySM } from "@/domains/design/components/body-sm"
import { BodyXs } from "@/domains/design/components/body-xs"
import { cn, formatCurrency } from "@/domains/library"
import useResponsive from "@/hooks/use-responsive"

export type INftBreadcrumbLockStore = { id: number; isScalest: boolean; power: number; lockAmount: number }

export const NftBreadcrumbWidget = ({ nft }: { nft: INftBreadcrumbLockStore }) => {
  const { isMobile } = useResponsive()
  const title = nft.isScalest ? "Scalest" : "Scalar"
  const wrapper = NFT_BREADCRUMB_WIDGET_COLORS[nft.isScalest ? "scalest" : "scalar"].wrapper
  const percentage = NFT_BREADCRUMB_WIDGET_COLORS[nft.isScalest ? "scalest" : "scalar"].percentage
  const text = NFT_BREADCRUMB_WIDGET_COLORS[nft.isScalest ? "scalest" : "scalar"].text

  if (isMobile) {
    return (
      <BodySM As="span" className="flex items-center gap-1 text-sm font-light text-t100">
        #{nft.id}
      </BodySM>
    )
  }

  return (
    <div className="flex w-full items-center justify-between gap-2">
      <BodySM As="div" className="font-light text-t100">
        #{nft.id}
      </BodySM>

      <div
        className={cn(
          "relative flex h-[18px] w-[120px] items-center justify-between overflow-hidden rounded-xl",
          wrapper,
        )}
      >
        <BodyXs As="div" className={cn("absolute inset-0 flex items-center justify-center font-light", text)}>
          {title} - {formatCurrency(nft.lockAmount, 0)}
        </BodyXs>
        <div
          className={cn("rounded-l-xl rounded-r-sm text-center", percentage)}
          style={{ width: `${nft.power * 100}%` }}
        >
          &nbsp;
        </div>
      </div>
    </div>
  )
}
